import { isTokenExpired, logout } from "./authUtils";

const fetchWithToken = async (
  url: string,
  options: RequestInit = {},
): Promise<Response> => {
  const token = localStorage.getItem("token");

  if (isTokenExpired(token as any)) {
    logout();
    throw new Error("Session Timeout. Please login aagain.");
  }

  const headers: Record<string, string> =
    (options.headers as Record<string, string>) || {};

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  options.headers = headers;

  try {
    const response = await fetch(url, options);

    if (response.status === 401) {
      throw new Error("Unauthorized");
    }

    return response;
  } catch (error) {
    const msg =
      error instanceof Error ? error.message : "Apologies, an error occured!";
    throw new Error(msg);
  }
};

export default fetchWithToken;
